import type { ITabletopOrganization } from '~/types/tabletop'

// Whether the store's country is on the legacy-metrics list
export function checkIsLegacyMetricsCountry(
  store: ITabletopOrganization | undefined,
  legacyMetricsCountries: string[],
): boolean {
  if (!store) return false

  const country = (store?.country || '')?.trim()?.toUpperCase()

  return legacyMetricsCountries.some(
    (legacyCountry) => legacyCountry?.trim()?.toUpperCase() === country,
  )
}
